import { render, staticRenderFns } from "./ShopFooter.vue?vue&type=template&id=556843f7&"
import script from "./ShopFooter.vue?vue&type=script&lang=js&"
export * from "./ShopFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports